import dayjs from 'dayjs';
import { AnalysisViewFragment } from 'generated/graphql';
import { AggregatePeriod, TimeUnit } from 'v2/core/entities';
import { Analysis, QueryType } from 'v2/core/entities/analysis';
import {
  mapFromEdgeReporting,
  mapFromEdgeScope,
} from 'v2/core/repository/edge-server/analysis/fromEdgeAnalysis';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { NotebookView } from 'v2/views/layouts/notebook/types';

export function getNewAnalysisCompatibleWithOld(
  newAnalysis: AnalysisViewFragment,
): Analysis {
  return {
    ...newAnalysis,
    name: newAnalysis.title,
    query: {
      whereClause: EmptyWhereClause,
      dateRange: {
        type: 'last',
        unit: TimeUnit.Week,
        value: 12,
      },
      aggregatePeriod: AggregatePeriod.WEEK,
      timezone: '',
      taxonomyID: '',
    },
    scope: mapFromEdgeScope(newAnalysis.scope),
    createdAt: dayjs.unix(newAnalysis.createdAt),
    updatedAt: dayjs.unix(newAnalysis.updatedAt),
    createdBy: {
      ...newAnalysis.createdBy,
      firstName: newAnalysis.createdBy.firstName,
      lastName: newAnalysis.createdBy.lastName,
    },
    queryString: '',
    quickFilters: {},
    selectedView: NotebookView.Feedback,
    qbQuery: {
      whereClause: EmptyWhereClause,
      dateRange: {
        type: 'last',
        unit: TimeUnit.Week,
        value: 12,
      },
      aggregatePeriod: AggregatePeriod.WEEK,
      timezone: '',
      taxonomyID: '',
    },
    searchQuery: '',
    widgets: [],
    feedback: {
      query: {
        type: QueryType.Records,
        dateRange: {
          type: 'absolute',
          startAfter: dayjs.unix(newAnalysis.createdAt),
          endBefore: dayjs.unix(newAnalysis.updatedAt),
        },
        taxonomyID: '',
        whereClause: EmptyWhereClause,
        sortBy: { isAsc: false },
      },
    },
    originViewToken: newAnalysis.originAnalysisViewToken,
    isReportingDisabled: newAnalysis.isReportingDisabled,
    reportSchedule: mapFromEdgeReporting(newAnalysis.reporting),
    status: newAnalysis.status,
  };
}
